module.exports = __webpack_public_path__ + "static/media/denver-desktop.134f55d0.webp";